export default __webpack_public_path__ + "static/media/name.286f8fb1.png";